/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const Immutable = require('immutable');
const k = require('@gral/constants');
const App = require('@gral/app');
const server = require('../actions/server').default;
const act = require('../actions/actStore');
const actView = require('../actions/actView');
const Store = require('./store');
const moment = require('moment-timezone');

// State
let _data = Immutable.Map({});

class DataStore extends Store {
  static initClass() {
    this.prototype.storeDomain = 'data';
    this.prototype.supportedActions = [
      k.actionTypes.FETCH,
      k.actionTypes.FETCH_MULTIPLE,
      k.actionTypes.FETCH_SUCCESS,
      k.actionTypes.FETCH_ERROR,
      k.actionTypes.CREATE,
      k.actionTypes.CREATE_SUCCESS,
      k.actionTypes.CREATE_ERROR,
      k.actionTypes.COPY,
      k.actionTypes.COPY_SUCCESS,
      k.actionTypes.COPY_ERROR,
      k.actionTypes.UPDATE,
      k.actionTypes.UPDATE_SUCCESS,
      k.actionTypes.UPDATE_ERROR,
      k.actionTypes.DECOMMISSION,
      k.actionTypes.DECOMMISSION_OLD,
      k.actionTypes.SET_DATA_PATH,
      k.actionTypes.MARK_AS_STALE,
      k.actionTypes.DELETE_RESOURCE,
      k.actionTypes.UPLOAD,
      k.actionTypes.UPLOAD_SUCCESS,
      k.actionTypes.UPLOAD_ERROR,
      k.actionTypes.ADD_TASK,
      k.actionTypes.ADD_TASK_SUCCESS,
      k.actionTypes.ADD_TASK_ERROR,
      k.actionTypes.PUSH,
      k.actionTypes.PUSH_SUCCESS,
      k.actionTypes.PUSH_ERROR,
      k.actionTypes.LINK_LAYER_TO_VIEW,
      k.actionTypes.LINK_LAYER_TO_VIEW_SUCCESS,
      k.actionTypes.LINK_LAYER_TO_VIEW_ERROR,
      k.actionTypes.UNLINK_LAYER_FROM_VIEW,
      k.actionTypes.UNLINK_LAYER_FROM_VIEW_SUCCESS,
      k.actionTypes.UNLINK_LAYER_FROM_VIEW_ERROR,
      k.actionTypes.LINK_RULESET_TO_LAYER,
      k.actionTypes.LINK_RULESET_TO_LAYER_SUCCESS,
      k.actionTypes.LINK_RULESET_TO_LAYER_ERROR,
      k.actionTypes.UNLINK_RULESET_FROM_LAYER,
      k.actionTypes.UNLINK_RULESET_FROM_LAYER_SUCCESS,
      k.actionTypes.UNLINK_RULESET_FROM_LAYER_ERROR,
      k.actionTypes.ATTACH_DEVICE,
      k.actionTypes.ATTACH_DEVICE_SUCCESS,
      k.actionTypes.ATTACH_DEVICE_ERROR,
      k.actionTypes.DETACH_DEVICE,
      k.actionTypes.DETACH_DEVICE_SUCCESS,
      k.actionTypes.DETACH_DEVICE_ERROR,
      k.actionTypes.ATTACH_SENSOR,
      k.actionTypes.ATTACH_SENSOR_SUCCESS,
      k.actionTypes.ATTACH_SENSOR_ERROR,
      k.actionTypes.DETACH_SENSOR,
      k.actionTypes.DETACH_SENSOR_SUCCESS,
      k.actionTypes.DETACH_SENSOR_ERROR,
      k.actionTypes.UNSET_PARAMETER,
      k.actionTypes.UNSET_PARAMETER_SUCCESS,
      k.actionTypes.UNSET_PARAMETER_ERROR,
      k.actionTypes.LOGOUT,
      k.actionTypes.CHANGE_ORGANIZATION_ROLE,
      k.actionTypes.ROUTE_CHANGED,
      k.actionTypes.MQTT_RX,
      k.actionTypes.SET_ACTION_TABLE,
    ];
  }
  getDataState() {
    return _data;
  }

  handleGenericFetchSuccess(action) {
    const { data, meta } = action.data;
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  handleGenericFetchError(action) {
    const { meta, errors } = action.data;
    const { dataPath } = errors.meta || meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    if (errors?._gral) {
      act.notify({ msg: _.capitalize(errors._gral) });
    }
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Fetch
  //-----------------------------------------------------
  _fetch(action) {
    const { url, dataPath, data } = action.data;
    const token = App.cxStore.getToken();

    const meta = {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
      userDateTime: moment.tz(moment.tz.guess()).format(),
      dataPath,
    };
    server.request(url, 'fetch', data, meta, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _push(action) {
    const { url, data, dataPath = 'push' } = action.data;
    const token = App.cxStore.getToken();
    const meta = {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
      userDateTime: moment.tz(moment.tz.guess()).format(),
      dataPath,
    };
    server.request(url, 'create', data, meta, token);
    return this.emitChange(action);
  }

  _pushSuccess(action) {
    return this.emitChange(action);
  }

  _pushError(action) {
    const { errors } = action.data;
    if (errors.error) {
      act.notify({ msg: _.capitalize(errors.error) });
    } else if (errors?._gral) {
      act.notify({ msg: _.capitalize(errors._gral) });
    }
    return this.emitChange(action);
  }

  _fetchMultiple(action) {
    const rsrcs = action.data;
    const token = App.cxStore.getToken();
    if (!(rsrcs != null ? rsrcs.length : undefined)) {
      return;
    }

    for (const rsrc of Array.from(rsrcs)) {
      const { url, dataPath, data, callback } = rsrc;
      rsrc.organizationId = App.cxStore.getOrganizationId();
      rsrc.roleId = App.cxStore.getRoleId();
      rsrc.userDateTime = moment.tz(moment.tz.guess()).format();
      server.request(url, 'fetch', data, rsrc, token, callback);
      _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    }
    return this.emitChange(action);
  }

  _fetchSuccess(action) {
    let msg;
    const { data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);

    return this.emitChange(action);
  }

  _fetchError(action) {
    let msg;
    if (action?.data?.response?.status === 404) {
      this._doSetDataPath(action.data.dataPath, k.rsrcStates.IDLE, null, null);
      return this.emitChange(action);
    }
    const { errors, meta } = (msg = action.data);
    const { dataPath } = errors?.meta || meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Update
  //-----------------------------------------------------
  _update(action) {
    let left; //let meta;
    const { url, dataPath, attrs, fetch, reloadSettings } = action.data;
    const token = App.cxStore.getToken();
    const meta = {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
      dataPath,
      fetch, // in case of refetch on success,
      reloadSettings,
    };
    /*data*/
    server.request(url, 'update', attrs, meta, token);
    const storeAttrs = _data.getIn([dataPath, 'data']);
    let modelAttrs = storeAttrs ? storeAttrs.toJS() : {};

    // BREAKING CHANGE?
    // Why do we need to merge the form state with the store? may cause inconsistencies
    // Incoming API data and outcoming data does not have to be the same
    // _.extend(modelAttrs, attrs);
    modelAttrs = {};
    //
    this._doSetDataPath(dataPath, k.rsrcStates.SYNCING, modelAttrs, {});
    return this.emitChange(action);
  }

  _updateSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath, fetch, reloadSettings } = meta;
    // Sometimes we need to do a re-fetch after succesfully updating
    if (fetch) {
      actView.fetch(fetch);
    } else {
      this._doSetDataPath(dataPath, k.rsrcStates.IDLE, data, {});
      this._setStale(dataPath, false);
    }
    return this.emitChange(action);
  }

  _updateError(action, options) {
    let msg;
    if (options == null) {
      options = {};
    }
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    if (errors.error) {
      act.notify({ msg: _.capitalize(errors.error) });
    } else if (errors?._gral) {
      act.notify({ msg: _.capitalize(errors._gral) });
    }
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, undefined, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Decommission
  //-----------------------------------------------------
  _decommissionOld(action) {
    // Specific update with re-fetch
    const { url, fetch } = action.data;
    const token = App.cxStore.getToken();
    const meta = {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
      fetch,
    };

    const attrs = { isAlive: false };
    return server.request(url, 'update', attrs, meta, token);
  }
  //-----------------------------------------------------
  // ## Create
  //-----------------------------------------------------
  _create(action) {
    let rsrc;
    const { url, dataPath, attrs } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.url = url;
    rsrc.dataPath = dataPath; //edit_modelName
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request(url, 'create', attrs, rsrc, token);
    const storeAttrs = _data.getIn([dataPath, 'data']);
    let modelAttrs = storeAttrs ? storeAttrs.toJS() : {};
    _.extend(modelAttrs, attrs);
    this._doSetDataPath(dataPath, k.rsrcStates.SYNCING, modelAttrs, {});
    return this.emitChange(action);
  }

  _createSuccess(action) {
    return this._updateSuccess(action);
  }
  _createError(action) {
    return this._updateError(action);
  }

  //-----------------------------------------------------
  // ## Copy
  //-----------------------------------------------------
  _copy(action) {
    let left;
    let rsrc;
    const { url, dataPath, attrs } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.url = url;
    rsrc.dataPath = dataPath;
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request(url, 'copy', attrs, rsrc, token);
    const modelAttrs = (left = __guard__(_data.getIn([dataPath, 'data']), x => x.toJS())) != null ? left : {};
    _.extend(modelAttrs, attrs);
    this._doSetDataPath(dataPath, k.rsrcStates.SYNCING, modelAttrs, {});
    return this.emitChange(action);
  }

  _copySuccess(action) {
    return this._updateSuccess(action);
  }
  _copyError(action) {
    return this._updateError(action);
  }

  //-----------------------------------------------------
  // ## Link Layer to View
  //-----------------------------------------------------
  _linkLayerToView(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/linkLayerToView', 'linkLayerToView', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _linkLayerToViewSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _linkLayerToViewError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Unlink Layer from View
  //-----------------------------------------------------
  _unlinkLayerFromView(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/unlinkLayerFromView', 'unlinkLayerFromView', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _unlinkLayerFromViewSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _unlinkLayerFromViewError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Link Ruleset to Layer
  //-----------------------------------------------------
  _linkRulesetToLayer(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/linkRulesetToLayer', 'linkRulesetToLayer', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _linkRulesetToLayerSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _linkRulesetToLayerError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Unlink Ruleset from Layer
  //-----------------------------------------------------
  _unlinkRulesetFromLayer(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/unlinkRulesetFromLayer', 'unlinkRulesetFromLayer', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _unlinkRulesetFromLayerSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _unlinkRulesetFromLayerError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Attach Device
  //-----------------------------------------------------
  _attachDevice(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    rsrc.dataPath = dataPath;
    server.request('/api/v2/attachDevice', 'attachDevice', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _attachDeviceSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _attachDeviceError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    if (errors?._gral) {
      act.notify({ msg: _.capitalize(errors._gral) });
    }
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Detach Device
  //-----------------------------------------------------
  /*   _detachDevice(action) {
      let rsrc;
      const { data, dataPath } = (rsrc = action.data);
      const token = App.cxStore.getToken();
      rsrc.organizationId = App.cxStore.getOrganizationId();
      rsrc.roleId = App.cxStore.getRoleId();
      server.request('/api/v2/detachDevice', 'detachDevice', data, rsrc, token);
      _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
      return this.emitChange(action);
    }
   */
  _detachDeviceSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _detachDeviceError(action) {
    let msg;

    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    if (errors?._gral) {
      act.notify({ msg: _.capitalize(errors._gral) });
    }
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Attach Sensor
  //-----------------------------------------------------
  _attachSensor(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/attachSensor', 'attachSensor', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _attachSensorSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _attachSensorError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Detach Sensor
  //-----------------------------------------------------
  _detachSensor(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/detachSensor', 'detachSensor', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _detachSensorSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _detachSensorError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Unset parameter
  //-----------------------------------------------------
  _unsetParameter(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/unsetParameter', 'unsetParameter', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _unsetParameterSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _unsetParameterError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  _decommission(action) {
    let rsrc;
    const { data, dataPath } = (rsrc = action.data);
    const token = App.cxStore.getToken();
    rsrc.organizationId = App.cxStore.getOrganizationId();
    rsrc.roleId = App.cxStore.getRoleId();
    server.request('/api/unsetParameter', 'decommission', data, rsrc, token);
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.SYNCING);
    return this.emitChange(action);
  }

  _decommissionSuccess(action) {
    let msg;
    const { url, data, meta } = (msg = action.data);
    const { dataPath } = meta;
    const newData = data;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, newData, {});
    this._setStale(dataPath, false);
    return this.emitChange(action);
  }

  _decommissionError(action) {
    let msg;
    const { url, data, errors, meta } = (msg = action.data);
    const { dataPath } = meta;
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, null, errors);
    return this.emitChange(action);
  }

  //-----------------------------------------------------
  // ## Uploads
  //-----------------------------------------------------
  /*  _upload(action) {
    const { dataPath, data, file } = action.data;
    const token = App.cxStore.getToken();
    const meta = {
      organizationId: App.cxStore.getOrganizationId(),
      roleId: App.cxStore.getRoleId(),
      userDateTime: moment.tz(moment.tz.guess()).format(),
      dataPath,
      data,
    };
    _data = _data.setIn([dataPath, data.name, 'fOngoing'], true);
    _data = _data.setIn([dataPath, data.name, 'data'], null);
    server.multipartRequest('/api/uploadFile', 'upload', data, meta, token, file);
    return this.emitChange(action);
  } */

  /* _uploadSuccess(action) {
    const { data, meta } = action.data;
    const { dataPath } = meta;
    _data = _data.setIn([dataPath, data.name, 'fOngoing'], false);
    _data = _data.setIn([dataPath, data.name, 'data'], data);
    return this.emitChange(action);
  }

  _uploadError(action) {
    const { data, errors } = action.data;
    const { dataPath } = action.data;
    act.notify({ msg: _.capitalize(errors._gral || errors.error) });
    _data = _data.setIn([dataPath, data.name, 'fOngoing'], false);
    _data = _data.setIn([dataPath, data.name, 'data'], null);
    return this.emitChange(action);
  } */

  //-----------------------------------------------------
  // # mqtt
  //-----------------------------------------------------
  _mqttRx(action) {
    const { topic, message } = action.data;
    const dataPath = this.getDataPathFromTopic(topic);
    this._doSetDataPath(dataPath, k.rsrcStates.IDLE, message);
    return this.emitChange(action);
  }

  getDataPathFromTopic(topic) {
    const re = RegExp('^(?:/1/)(?:\\w+/)(.+)$');
    return topic.match(re)[1];
  }

  //-----------------------------------------------------
  // ## Other
  //-----------------------------------------------------
  _setDataPath(action) {
    const { dataPath, data } = action.data;
    _data = _data.setIn([dataPath, 'state'], k.rsrcStates.IDLE);
    _data = _data.setIn([dataPath, 'data'], Immutable.fromJS(data));
    this.emitChange(action);
  }

  _doSetDataPath(dataPath, state, data, errors) {
    const newState = state != null ? state : k.rsrcStates.IDLE;
    _data = _data.setIn([dataPath, 'state'], newState);
    if (data && Array.isArray(data) || data && Object.keys(data).length > 0) {
      _data = _data.setIn([dataPath, 'date'], new Date());
      const newData = data != null ? Immutable.fromJS(data) : null;
      _data = _data.setIn([dataPath, 'data'], newData);
    }

    const newErrors = errors != null ? Immutable.fromJS(errors) : null;
    _data = _data.setIn([dataPath, 'errors'], newErrors);

    return _data;
  }

  _deleteResource(action) {
    const dataPath = action.data;
    _data = _data.remove(dataPath);

    return this.emitChange(action);
  }

  _markAsStale(action) {
    const dataPath = action.data;
    if (dataPath.constructor === Array) {
      dataPath.map(dP => {
        if (_data.get(dP)) {
          return this._setStale(dP, true);
        }
      });
    } else {
      if (!_data.get(dataPath)) {
        return;
      }
      this._setStale(dataPath, true);
    }
    return this.emitChange(action);
  }

  _setStale(dataPath, fStale) {
    return (_data = _data.setIn([dataPath, 'fStale'], fStale));
  }

  _logout(action) {
    // clear dataStore on logOut
    _data = Immutable.Map();
    return this.emitChange(action);
  }

  _routeChanged(action) {
    let oldData;
    const routePath = __guard__(App.routeStore.getLastState(), x => x.path);
    const actionPath = action.data.path;
    if (routePath != null && actionPath != null) {
      if (routePath !== actionPath) {
        // don't reset if editing same entity
        const actionSegments = actionPath.split('/');
        const routeSegments = routePath.split('/');
        if (actionSegments[1] !== routeSegments[1]) {
          // diff entity
          oldData = _data;
          if (action.data.cleanDatapath == true) {
            _data = Immutable.Map();
          }
          // we have to design a better way to do this (separate permanent/volatile storage)
          if (oldData.get('profiles')) {
            _data = _data.set('profiles', oldData.get('profiles'));
          }
          if (oldData.get('_logo')) {
            _data = _data.set('_logo', oldData.get('_logo'));
          }
        }
      }
    } else {
      oldData = _data;
      oldData.map((dP, index) => {
        if (!(index === 'profiles' || index === '_logo')) {
          return this._setStale(index, true);
        }
      });
    }
    return this.emitChange(action);
  }

  _setActionTable(action) {
    const newData = action.data != null ? Immutable.fromJS(action.data) : null;
    _data = _data.setIn(['action', 'data'], newData);

    return this.emitChange(action);
  }
}
DataStore.initClass();

module.exports = App.dataStore = new DataStore();

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
